import React from "react";
import moment from 'moment';
import { PaperClipIcon, DocIcon } from '../Icon'
import { testJSON } from '../../utils/commonFunctions'
interface Props {
    data: any;
    tableHeader: any;
    editEntry?: Function;
    deleteEntry?: Function;
    download?: Function;
    loginData?: any;
}
class TableData extends React.Component<Props> {

    render() {
        const {
            data,
            tableHeader,
            editEntry,
            deleteEntry,
            download,
            loginData
        } = this.props

        const { user_role_id } = loginData;

        return data.map((dataItem: any, index: number) => {

            let finalDate = dataItem.date_of_invoice ? moment(dataItem.date_of_invoice).format('DD-MM-YYYY') : dataItem.date ? moment(dataItem.date).format('DD-MM-YYYY') : '';


            let finalName = dataItem?.name?.split(' ').length > 1 ? dataItem?.name?.split(' ').join('_') : dataItem?.name;

            let finalInvoiceName = finalDate ? `${ finalDate }_${ finalName }` : finalName;

            let uploadData = testJSON(dataItem.upload) ? JSON.parse(dataItem.upload) : null

            let uploadCount = uploadData && uploadData.length ? uploadData.length : null;

            let dateSet = new Set(["date", "date_of_invoice",
                "dor_in_bank_cash", "invoice_voucher_date", "voucher_invoice_date", "dop_in_bank_cash", "updated_at", "voucher_invoice_date"])

            if (dataItem) {
                return (
                    <tr key={index}>
                        {
                            tableHeader.map((item: any, i: number) => {
                                if (item.value === 'name') {
                                    return <td><p className="ellipsis"><DocIcon />{dataItem[item.value]}</p></td>
                                }
                                else if (item.value === 'upload') {
                                    return uploadCount ? <td className="position-relative">
                                        <PaperClipIcon />
                                        <span className="badge count-badge">         {uploadCount}
                                        </span>
                                    </td> : <td> --/-- </td>
                                }
                                else if (item.value === 'net_payment_made' || item.value === 'net_amount_received') {

                                    return dataItem[item.value] ? <td><span className="label label-success">Done</span></td> : <td><span className="label label-warning">Pending</span></td>
                                }
                                else if (item.value === 'bill_number') {


                                    if (dataItem['invoice_voucher_number']) return <td><p className="ellipsis">{dataItem['invoice_voucher_number']}</p></td>
                                    if (dataItem['voucher_invoice_number']) return <td><p className="ellipsis">{dataItem['voucher_invoice_number']}</p></td>
                                    if (dataItem['receipt_number']) return <td><p className="ellipsis">{dataItem['receipt_number']}</p></td>
                                    if (dataItem['bill_number']) return <td><p className="ellipsis">{dataItem['bill_number']}</p></td>

                                    return <td>--/--</td>
                                }
                                else if (dateSet.has(item.value)) {
                                    return <td> {dataItem[item.value] ? moment(dataItem[item.value]).format('DD-MM-YYYY') : '--/-- '}</td>
                                }
                                else if (dataItem[item.value]) {
                                    return <td><p className="ellipsis" data-text={dataItem[item.value]}> {dataItem[item.value]}</p></td>
                                }
                                else {
                                    return <td>--/--</td>
                                }

                            })
                        }
                        <td>
                            <ul className="list-group list-group-horizontal action-list">
                                {download ? <li>
                                    <img src="/img/icons/IconDownload.svg" />
                                </li> : null}
                                {deleteEntry && user_role_id === 1 ? <li className="pointer" onClick={() => deleteEntry(data[index].id)}>
                                    <img src="/img/icons/IconDelete.svg" />
                                </li> : null}
                                {editEntry ? <li className="pointer" onClick={() => editEntry(data[index].id)} >
                                    <img src="/img/icons/IconEdit.svg" />
                                </li> : null}
                            </ul>
                        </td>
                    </tr>
                )
            }
        })
    }
}

export default TableData;